import React, {useCallback, useContext, useEffect, useRef, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {WarningDialog} from 'components/Shared/Dialogs'
import {releaseLock} from "../services";

const NavigatePreventContext = React.createContext({
  setNavigationBlocked: () => {},
  setNavigationUnlocked: () => {}
})

export function NavigatePreventProvider({children}) {
  const [unlockedNavigation, setUnlockedNavigation] = useState(true)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [target, setTarget] = useState()
  const [lockId, setLockId] = useState(null)

  const unblockHandle = useRef()

  const history = useHistory()

  useEffect(() => {
    unblockHandle.current = history.block((location, action) => {
      if (!unlockedNavigation) {
        setTarget({pathname: location.pathname, action: action})
        setDialogOpen(true)
      }
      return unlockedNavigation
    })
    return function () {
      unblockHandle.current && unblockHandle.current()
    }
  })

  const setNavigationBlocked = useCallback((lockId) => {
    setUnlockedNavigation(false)
    setLockId(lockId)
  }, [])

  const setNavigationUnlocked = useCallback(historyCallback => {
    setUnlockedNavigation(true)
    unblockHandle.current && unblockHandle.current()
    if (historyCallback) {
      historyCallback(history)
    }
  }, [history])

  const goToTarget = () => {
    if (target.action === 'POP') {
      history.goBack()
    } else {
      history.push(target.pathname)
    }

  }

  const closeDialog = (result) => {
    if (result) {
      if (lockId) {
        releaseLock(lockId)
        setLockId(null)
      }
      setNavigationUnlocked()
      unblockHandle.current()
      goToTarget()
      setTarget(null)
      setDialogOpen(false)
    } else {
      setDialogOpen(false)
    }
  }

  const value = {
    setNavigationBlocked: setNavigationBlocked,
    setNavigationUnlocked: setNavigationUnlocked
  }

  return (
    <NavigatePreventContext.Provider value={value}>
      <WarningDialog open={dialogOpen}
                     onClose={closeDialog}
                     title={'notifications.warnings.exitForm.title'}
                     content={'notifications.warnings.exitForm.message'}
      />
      {children}
    </NavigatePreventContext.Provider>
  )
}

export function useNavigatePrevent() {
  const {setNavigationBlocked, setNavigationUnlocked} = useContext(NavigatePreventContext)

  return {setNavigationBlocked, setNavigationUnlocked}
}
